"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeLessonsUnique = exports.mergeDuplicateLessons = exports.sortLessons = exports.createLesson = exports.createLessonWithParticipants = exports.createLessonWithParticipantsId = exports.getParticipantCount = exports.parseParticipants = exports.p2rooms = exports.p2teachers = exports.p2classes = exports.p2students = exports.getDefaultLesson = exports.getDefaultNonUniqueLesson = void 0;
const Participant_1 = require("./Participant");
const mergeBy_1 = require("../util/mergeBy");
const getDefaultNonUniqueLesson = () => ({
    id: "",
    isEmpty: true,
    dayIndex: -1,
    timeIndex: -1,
    name: "",
    teacher: "",
    room: "",
    participants: [],
});
exports.getDefaultNonUniqueLesson = getDefaultNonUniqueLesson;
const getDefaultLesson = () => (Object.assign(Object.assign({}, exports.getDefaultNonUniqueLesson()), { students: [], classes: [], teachers: [], rooms: [] }));
exports.getDefaultLesson = getDefaultLesson;
const p2students = (participants) => [
    ...new Set([...participants.filter((p) => p.labels[0] === "student").map((p) => p.text)]),
];
exports.p2students = p2students;
const p2classes = (participants) => [
    ...new Set([...participants.filter((p) => p.labels[0] === "class").map((p) => p.text)]),
];
exports.p2classes = p2classes;
const p2teachers = (participants) => [
    ...new Set([...participants.filter((p) => p.labels[0] === "teacher").map((p) => p.text)]),
];
exports.p2teachers = p2teachers;
const p2rooms = (participants) => [
    ...new Set([...participants.filter((p) => p.labels[0] === "room").map((p) => p.text)]),
];
exports.p2rooms = p2rooms;
const parseParticipants = (participants) => {
    const ret = {
        students: [],
        teachers: [],
        rooms: [],
        classes: [],
        allParticipants: [],
    };
    participants.forEach((p) => {
        const kind = p.labels[0];
        ret["allParticipants"].push(p.text);
        if (kind === "student")
            ret.students.push(p.text);
        else if (kind === "teacher")
            ret.teachers.push(p.text);
        else if (kind === "class")
            ret.classes.push(p.text);
        else if (kind === "room")
            ret.rooms.push(p.text);
        else
            throw new Error("Invalid kind");
    });
    return ret;
};
exports.parseParticipants = parseParticipants;
const getParticipantCount = ({ students, classes, teachers, rooms }) => students.length + classes.length + teachers.length + rooms.length;
exports.getParticipantCount = getParticipantCount;
const createLessonWithParticipantsId = (lesson) => {
    const { isEmpty, dayIndex, timeIndex, name } = lesson;
    const id = `${isEmpty}/${dayIndex}/${timeIndex}/${name}`;
    return id;
};
exports.createLessonWithParticipantsId = createLessonWithParticipantsId;
const createLessonWithParticipants = (data = exports.getDefaultNonUniqueLesson()) => {
    const { participants } = data;
    const teachers = exports.p2teachers(participants);
    const rooms = exports.p2rooms(participants);
    const teacher = teachers.join(", ").trim();
    const room = rooms.join(", ").trim();
    const almostLesson = Object.assign(Object.assign({}, data), { teacher,
        room });
    const id = exports.createLessonWithParticipantsId(almostLesson);
    return Object.assign(Object.assign({}, almostLesson), { id });
};
exports.createLessonWithParticipants = createLessonWithParticipants;
const createLesson = (data = exports.getDefaultNonUniqueLesson()) => {
    const { participants } = data, rest = __rest(data, ["participants"]);
    const teachers = exports.p2teachers(participants);
    const rooms = exports.p2rooms(participants);
    const classes = exports.p2classes(participants);
    const students = exports.p2students(participants);
    return Object.assign(Object.assign({}, rest), { teachers,
        rooms,
        classes,
        students });
};
exports.createLesson = createLesson;
const sortLessons = (lessons) => [...lessons].sort((A, B) => {
    if (A.dayIndex < B.dayIndex) {
        return -1;
    }
    if (A.dayIndex > B.dayIndex) {
        return 1;
    }
    if (A.timeIndex < B.timeIndex) {
        return -1;
    }
    if (A.timeIndex > B.timeIndex) {
        return 1;
    }
    return 0;
});
exports.sortLessons = sortLessons;
const mergeDuplicateLessonsStrat = (left, right) => (Object.assign(Object.assign({}, left), { participants: Participant_1.mergeDuplicateParticipantsInLessons([...left.participants, ...right.participants]) }));
exports.mergeDuplicateLessons = mergeBy_1.mergeBy("id", mergeDuplicateLessonsStrat);
const makeLessonsUnique = (nonUniqueLessons = []) => {
    const merged = exports.mergeDuplicateLessons(nonUniqueLessons);
    const sorted = exports.sortLessons(merged);
    const finished = sorted.map(exports.createLesson);
    return finished;
};
exports.makeLessonsUnique = makeLessonsUnique;
//# sourceMappingURL=Lesson.js.map